import React from 'react';
import { CtaButton } from './CtaButton';
import { heroBadges } from '../data/content';
export function Hero() {
  return <header className="flex min-h-[calc(100svh-2.75rem)] w-full flex-col bg-ink px-5 pb-5 pt-4 text-white sm:px-8 sm:pb-8 sm:pt-6" data-id="element-164" data-mp="ej4n3wauu9ex">
      <div className="mx-auto flex w-full max-w-4xl flex-1 flex-col items-center justify-center text-center" data-id="element-165" data-mp="9ipd9eps7k1p">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-ember sm:text-sm" data-id="element-166" data-mp="4jvyzk2o7p0h">
          🏀 Basketball Ready 360
        </p>

        <p className="mt-2 hidden rounded-full border border-ember/40 bg-ember/10 px-3.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-ember-light sm:block sm:text-[11px]" data-id="element-167" data-mp="xbfm3f2e1n7r">
          🏀 Trusted by hundreds of coaches worldwide
        </p>

        <h1 className="mt-2.5 text-[26px] font-extrabold leading-[1.08] tracking-tight sm:mt-3 sm:text-4xl lg:text-5xl" data-id="element-168" data-mp="3d1ikl9ryvcnf">
          Plan Your Entire Basketball Year{' '}
          <span className="text-ember" data-id="element-169" data-mp="3814a7l2w7qm8">In Under 5 Minutes.</span>
        </h1>

        <p className="mt-2.5 max-w-xl text-[13px] leading-snug text-neutral-400 sm:mt-3 sm:text-sm" data-id="element-170" data-mp="3j9u2j3pddwnx">
          The complete basketball bible for coaches and PE teachers — 200+ sessions, 101
          shooting drills, tactics, planning tools and more. Everything done for you.
        </p>

        <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[10px] font-bold sm:mt-3 sm:gap-x-4 sm:text-xs" data-id="element-171" data-mp="3e8egp9fdbm4h">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1" data-id="element-172" data-mp="3599f1u8ifco3">
              <span aria-hidden="true" data-id="element-173" data-mp="35akni7cwh8lj">✅</span>
              {badge}
            </li>)}
        </ul>

        <div className="mt-3 flex min-h-0 w-full max-w-sm flex-1 items-center justify-center sm:mt-4 sm:max-w-md" data-id="element-174" data-mp="2viy43nqes37p">
          <img src="https://cdn.magicpatterns.com/uploads/47CubgFgrQ6UEwgw6FrSYw/ChatGPT_Image_28_ago_2026,_12_35_51-Photoroom.png" alt="Basketball Ready 360 complete bundle: 6 volumes, tablet, desktop, phone, coaching clipboard and basketball" className="max-h-[36vh] w-full object-contain sm:max-h-[42vh]" data-id="element-175" data-mp="2hinawe1mmcjd" />
        </div>

        <div className="mt-4 w-full max-w-sm sm:max-w-md" data-id="element-176" data-mp="n9i2r9bi38sj">
          <CtaButton className="!py-3.5 !text-[13px] sm:!py-4 sm:!text-base" data-id="element-177" data-mp="id050tel8app" />
        </div>

        <p className="mt-2.5 text-[11px] font-semibold text-neutral-300 sm:mt-3 sm:text-xs" data-id="element-178" data-mp="de6rj0zawjpj">
          🔒 Secure Payment <span className="text-neutral-600" data-id="element-179" data-mp="1b0dsm0webtx5">·</span> ⚡ Instant Access{' '}
          <span className="text-neutral-600" data-id="element-180" data-mp="161j88uis5xax">·</span> 🛡️ 7-Day Guarantee
        </p>
      </div>
    </header>;
}